import { Select, Input, DatePicker, InputNumber, message } from "antd";
import "./newClientEscalation.css";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { buildSortedOptions, newClientEscalation } from "../../../utils/Constants";
import { useDispatch } from "react-redux";
import {
  fetchUsersThunk,
} from "../../../store/thunks/usersThunk";
import {
  fetchProcessesByClientThunk,
} from "../../../store/thunks/processesThunk";

import { fetchClientsByDeptThunk } from "../../../store/thunks/clientsThunk";

import {
  fetchDepartmentsSimpleThunk,
} from "../../../store/thunks/departmentsThunk";
import secureLocalStorage from "react-secure-storage";
import { fetchDashboardUsersThunk } from "../../../store/thunks/dashboardThunk";


const onSearch = (value) => {};

const NewClientEscalation = ({isEditMode = false,
  editingRecord = null}) => {
    console.log("IS EDIT MODE:", isEditMode);
console.log("EDITING RECORD:", editingRecord);
  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);
  const [clients, setClients] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [reportingTLs, setReportingTLs] = useState([]);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const fetchDepartments = async () => {
    try {
      const response = await dispatch(
        fetchDepartmentsSimpleThunk({
          route: "departments",
          action: "findAll",
        }),
      ).unwrap();

      const options =
        response?.map((department) => ({
          label: department?.name,
          value: department?._id,
        })) || [];
      console.log("object:",options)
      setDepartments(options);
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
    }
  };
  const fetchReportingTLByDepartment = async (departmentId) => {
    setReportingTLs([]);

    if (!departmentId) return;

    try {
      const payload = {
        route: "users",
        action: "findAll",
        fields: ["tl", "atl"],
        role: slsRole,
        lIUId: slsLIUId,
        departments: [departmentId],
      };

      const result = await dispatch(
        fetchDashboardUsersThunk(payload)
      ).unwrap();

      const users = Array.isArray(result) ? result : [];

      const tlUsers = users.filter(
        (user) =>
          user?.role === process.env.REACT_APP_TLROLE ||
          user?.role === process.env.REACT_APP_ATLROLE
      );

      setReportingTLs(
        buildSortedOptions(
          tlUsers,
          "name",
          "_id",
          true,
          [
            process.env.REACT_APP_TLROLE.toLowerCase(),
            process.env.REACT_APP_ATLROLE.toLowerCase(),
          ]
        )
      );
    } catch (error) {
      console.error(
        "Error fetching Reporting TL by department:",
        error
      );

      setReportingTLs([]);
    }
  };
  const fetchClientsByDepartment = async (departmentId) => {
    setClients([]);
    setProcesses([]);

    setGlobalState((prev) => ({
      ...prev,
      eClientName: null,
      eClientNameVal: null,
      eProcessName: null,
      eProcessNameVal: null,
    }));

    if (!departmentId) return;

    try {
      const response = await dispatch(
        fetchClientsByDeptThunk({
          department: departmentId,
        }),
      ).unwrap();

      setClients(
        response?.map((client) => ({
          label: client?.name,
          value: client?._id,
        })) || [],
      );
    } catch (error) {
      console.error("Error fetching clients by department:", error);
      setClients([]);
    }
  };
  const fetchProcessesByClient = async (clientId,departmentId) => {
    setProcesses([]);

    setGlobalState((prev) => ({
      ...prev,
      eProcessName: null,
      eProcessNameVal: null,
    }));

    if (!clientId) return;

    try {
      const response = await dispatch(
        fetchProcessesByClientThunk({
          client: clientId,
          department: departmentId
        }),
      ).unwrap();

      setProcesses(
        response?.map((process) => ({
          label: process?.name,
          value: process?._id,
        })) || [],
      );
    } catch (error) {
      console.error("Error fetching processes by client:", error);
      setProcesses([]);
    }
  };
  const fetchAgentByEmpId = async (empId) => {
    if (!empId) {
      setGlobalState((prev) => ({
        ...prev,
        eAgentName: null,
        eAgentNameVal: null,
      }));

      return;
    }

    try {
      const response = await dispatch(
        fetchUsersThunk({
          searchIn: "users",
          callActionFrom: "client-escalation",
          hasSearchedValue: "yes",
          searchKeyword: String(empId),
          pagination: {
            current: 1,
            page: 1,
            pageSize: 10,
          },
        }),
      ).unwrap();

      console.log("USER SEARCH RESPONSE:", response);

      const users = response?.data || [];

      const agent = users.find(
        (user) =>
          String(user?.empID) === String(empId) &&
          (user?.role?.toLowerCase() !==
            process.env.REACT_APP_AROLE?.toLowerCase()),
      );

      if (agent) {
        setGlobalState((prev) => ({
          ...prev,
          eAgentName: agent?.name,
          eAgentNameVal: agent?.name,
        }));
      } else {
        setGlobalState((prev) => ({
          ...prev,
          eAgentName: null,
          eAgentNameVal: null,
        }));

        message.error("Agent not found for this Emp ID.");
      }
    } catch (error) {
      console.error("Error fetching agent by Emp ID:", error);

      setGlobalState((prev) => ({
        ...prev,
        eAgentName: null,
        eAgentNameVal: null,
      }));

      message.error("Unable to fetch Agent details.");
    }
  };

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    if (enteredEmail) {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      setIsValidEmail(emailRegex.test(enteredEmail));
      setGlobalState((prevGlobalState) => {
        const newGlobalState = {
          ...prevGlobalState,
          eClientSpocEmailVal: "",
          eClientSpocEmail: emailRegex.test(enteredEmail),
        };
        return newGlobalState;
      });
    } else {
      setIsValidEmail("false");
    }
  };

  useEffect(() => {
    //fetchClients();
    fetchDepartments();
  }, []);

  return (
    <div id="antdformstyle">
      {newClientEscalation.map((section) => (
        <div key={section.key}>
          <div className="pb-16 cusFormTitle">{section.title}</div>
          <div className="details-container plr-16">
            {section.key === "rcaDetails"
              ? section.fields
                  .reduce((rows, field, index) => {
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field, i) => {
                        // Logic for RCA only
                        const shouldShow =
                          field.key === "rcaLevelOne" ||
                          (field.key === "rcaLevelTwo" &&
                            globalState?.rcaLevelOneVal) ||
                          (field.key === "rcaLevelThree" &&
                            globalState?.rcaLevelTwoVal) ||
                          (field.key === "rcaLevelFour" &&
                            globalState?.rcaLevelThreeVal);

                        if (!shouldShow) return null;

                        let options = field.options;
                        if (field.optionsByParent) {
                          const parentKey =
                            field.key === "rcaLevelTwo"
                              ? globalState?.rcaLevelOne
                              : field.key === "rcaLevelThree"
                                ? globalState?.rcaLevelTwo
                                : field.key === "rcaLevelFour"
                                  ? globalState?.rcaLevelThree
                                  : null;

                          options = parentKey
                            ? field.optionsByParent[
                                parentKey
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "")
                              ] || []
                            : [];
                        }

                        return (
                          <div key={field.key} className="details-inner">
                            <label className="formCusLabel">
                              {field.label}
                              {field.required && (
                                <span className="reqred">*</span>
                              )}
                            </label>
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              options={options}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: option?.label,
                                  [field.key]: val || field.errorMessage,

                                  ...(field.key === "rcaLevelOne" && {
                                    rcaLevelTwo: null,
                                    rcaLevelTwoVal: null,
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelTwo" && {
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelThree" && {
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                }));
                              }}
                            />

                            {globalState?.[`${field.key}`] ===
                              field.errorMessage && (
                              <div className="error">{field.errorMessage}</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))
              : section.fields
                  .reduce((rows, field, index) => {
                    // Group into pairs
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field) => (
                        <div key={field.key} className="details-inner">
                          <label className="formCusLabel">{field.label}{field.required && (
                                <span className="reqred">*</span>
                              )}</label>

                          {field.type === "input" && (
                            <Input
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) => {
                                if (field.validate === "email") {
                                  handleEmailChange(e);
                                }
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }));
                              }}
                            />
                          )}

                          {field.type === "number" && (
                            <InputNumber
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(value) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: value,
                                  [field.key]: value || field.errorMessage,
                                }));
                                if (
                                  field.key === "eEmpID" &&
                                  String(value || "").length >=2
                                ) {
                                  fetchAgentByEmpId(value);
                                }
                              }}
                            />
                          )}

                          {field.type === "date" && (
                            <DatePicker
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              disabledDate={(current) => {
                                if (
                                  field.key === "eTransactionDate" &&
                                  globalState?.eErrorRaiseDateVal
                                ) {
                                  return current.isAfter(
                                    globalState.eErrorRaiseDateVal,
                                    "day",
                                  );
                                }

                                return false;
                              }}
                              
                              onChange={(date) => {
                                const dayName = date ? date.format("ddd") : "";

                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: date,
                                  [field.key]: date || field.errorMessage,
                                  ...(field.key === "eTransactionDate"
                                    ? { eDayoftheweekVal: dayName || null }
                                    : {}),
                                }));
                              }}
                            />
                          )}

                          {field.type === "readonly" && (
                            <div className="readonly-field">
                              <span>{globalState?.[`${field.key}Val`]}</span>
                            </div>
                          )}

                          {field.type === "textarea" && (
                            <TextArea
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) =>
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }))
                              }
                            />
                          )}

                          {field.type === "select" && (
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              optionFilterProp="label"
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,

                                  [`${field.key}Val`]: option?.label || null,
                                  [field.key]: val || field.errorMessage,

                                  // Department changed
                                  ...(field.key === "eDepartmentName" && {
                                    eClientName: null,
                                    eClientNameVal: null,
                                    eProcessName: null,
                                    eProcessNameVal: null,
                                    eReportingTlName: null,
                                    eReportingTlNameVal: null,
                                  }),

                                  // Client changed
                                  ...(field.key === "eClientName" && {
                                    eProcessName: null,
                                    eProcessNameVal: null,
                                  }),
                                }));

                                if (field.key === "eDepartmentName") {
                                  fetchClientsByDepartment(val);
                                  fetchReportingTLByDepartment(val);
                                }

                                if (field.key === "eClientName") {
                                  fetchProcessesByClient(val,globalState?.eDepartmentName);
                                }
                              }}
                              onSearch={onSearch}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={
                                field.key === "eDepartmentName"
                                  ? departments
                                  : field.key === "eClientName"
                                    ? clients
                                    : field.key === "eProcessName"
                                      ? processes
                                      : field.key === "eReportingTlName"
                                        ? reportingTLs
                                        : field.options
                              }
                              disabled={
                                field.key === "eClientName"
                                  ? !globalState?.eDepartmentName
                                  : field.key === "eProcessName"
                                    ? !globalState?.eClientName
                                    : field.key === "eReportingTlName"
                                      ? !globalState?.eDepartmentName
                                      : false
                              }
                            />
                          )}
                         
                          {globalState?.[`${field.key}`] ===
                            field.errorMessage && (
                            <div className="error">{field.errorMessage}</div>
                          )}

                          {field.validate === "email" && !isValidEmail && (
                            <div className="error">
                              Please enter a valid email address.
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
          </div>
        </div>
      ))}
    </div>
  );
};
export default NewClientEscalation;
